module.exports = __webpack_public_path__ + "static/media/header-bg.9cab736a.png";